import { render } from "./EventRegistrationList.vue?vue&type=template&id=5134624a&scoped=true"
import script from "./EventRegistrationList.vue?vue&type=script&lang=js"
export * from "./EventRegistrationList.vue?vue&type=script&lang=js"

import "./EventRegistrationList.vue?vue&type=style&index=0&id=5134624a&scoped=true&lang=css"

import exportComponent from "D:\\Projects\\SPNM\\Core\\clientapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5134624a"]])

export default __exports__